var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "Qrcode", title: "二维码" } }, [
    _c("div", { staticClass: "qrcode_box" }, [
      _c("canvas", {
        ref: "qrCanvas",
        staticClass: "qrcode_canvas",
        style: { width: `${_vm.qrSize}px`, height: `${_vm.qrSize}px` },
        attrs: { width: _vm.qrSize, height: _vm.qrSize },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }